import { useEffect, useState } from "react";
import DateRangeDropdown from "../../../Components/AdministrativeSettings/DateRangeDropdown"
import ClearFilterButton from "../../../Components/ClearFilterButton"
import ParentStudiesListTable from "./ParentStudiesListTable"
import { useLocation, useNavigate } from "react-router-dom";
import TokenService from "../../../Services/Token.service";

function ParentStudies({ setEditingStudy, refreshTrigger }) {
    const userRestrictions = TokenService.getUserRestrictions() || [];
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');
    
    const navigate = useNavigate();
    const [isClearFilter, setIsClearFilter] = useState(false);
    const [filterCount, setFilterCount] = useState(0);
    const handleClearFilters = () => {
        setIsClearFilter(true);
        setTimeout(() => setIsClearFilter(false), 0);
    };

    const handleFilterCountChange = (count) => {
        setFilterCount(count); // Update filter count
    };

    const location = useLocation();
    useEffect(() => { 
        if (location.state?.toastMessage) {
                setShowToast(true);
                setToastMessage(location.state.toastMessage);
                setToastVariant(location.state.toastVariant);
            // showToast(location.state.toastMessage, location.state.toastVariant);

                // Clear location.state to prevent the toast from triggering on refresh
            navigate(location.pathname, { replace: true }); 

                // Clear toast state after displaying
                return () => {
                setShowToast(false);
                setToastMessage(null);
                setToastVariant(null);
            };
        }
    },[], [location.state, showToast, navigate]);

    return (<>
        <div className="el-bg-table">
            <div className="d-flex justify-content-between">
                <div className="d-flex justify-content-between align-items-center" >
                    {/* style={{ width: "45%" }} */}
                    <div className="d-flex justify-content-between align-items-center" style={{ marginRight: '15px' }}>
                        <h3>Parent Studies</h3>
                    </div>
                    {filterCount > 0 && (<ClearFilterButton handleClearFilters={handleClearFilters} />)}
                    {filterCount > 0 && (<span className="m-2">Filters applied: {filterCount}</span>)}
                </div>
            </div>
            <>
            <ParentStudiesListTable isClearFilter={isClearFilter} onFilterCountChange={handleFilterCountChange} refreshTrigger={refreshTrigger} onEditStudy={setEditingStudy}></ParentStudiesListTable>
            </>
        </div>
    </>)
}
export default ParentStudies